import { ButtonBase } from "@mui/material";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  border-top: 1px solid rgba(213, 213, 213, 0.6);
  padding: 16px;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

export const Button = styled.button`
  border-radius: 8px;
  color: #eaefff !important;
  height: 40px;
  cursor: pointer;
  width: 120px;
`;
